ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
t = require('views/internal/teacup-with-helpers')('request_to_join')
View = require 'view'
_ = require 'underscore'

template = t.renderable ({ email }) ->
  t.div '.big-message', ->
    t.h1 ->
      t.format 'request-access-to-board'

    t.p '.js-request-explanation', ->
      t.format 'looks-like-the-board-you-are-trying-to-access-is-private'

    t.p '.js-request-explanation', ->
      t.format 'request-access-from-the-board-admin'

    t.p '.js-request-explanation', ->
      t.button '.button.primary.request-access.js-request', ->
        t.format 'request-access'

    t.p '.js-request-explanation.quiet', ->
      t.format 'youre-signed-in-with-email', { email }

    t.p '.js-request-explanation.quiet', ->
      t.a { href: '/login?reauthenticate=true' }, ->
        t.format 'switch-accounts'

    t.p '.js-sent.hide', ->
      t.format 'request-sent'

    t.p '.js-error.hide', ->
      t.format 'unable-to-send-request'


module.exports = class RequestToJoinView extends View

  events: ->
    'click .js-request': (e) ->
      @$('.js-sent').toggleClass('disabled', true).prop('disabled', true)

      ApiPromise
        url: "/1/boards/#{ @options.idBoard }/requestToJoin"
        method: 'post'
      .then ->
        @$('.js-request-explanation').addClass('hide')
        @$('.js-sent').removeClass('hide')
      .catch ApiError, ->
        @$('.js-request-explanation').addClass('hide')
        @$('.js-error').removeClass('hide')
      .done()

  render: ->
    @$el.html(template({
      email: Auth.me().get('email')
    }))
    @




// WEBPACK FOOTER //
// ./app/scripts/views/board/request-to-join-view.coffee